// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/.pnpm/css-loader@6.11.0_webpack@5.106.2/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/.pnpm/css-loader@6.11.0_webpack@5.106.2/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
	margin: 0;
}

.WO8JZfaKjRnIyH4eGREN {
	position: absolute;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	overflow-y: auto;
	overflow-x: hidden;
	display: flex;
	flex-direction: column;
	background-color: #f6f4f1;
}

.POk2ODQ8g1C24rtnd0Yj {
	width: 100%;
	height: 100%;
}

.HQkGPWFwuPmBz9Rd5L5n {
	font-family: "Suranna", "sans-serif";
	font-weight: 400;
}

.rinBbFrkPv3bK7ZgkW6t {
	font-family: "Ubuntu", "sans-serif";
}

.QH2WsPgEwuZnEjgJYuYG {
	font-family: "Unna", "sans-serif";
}

.h6NXetLtM8f7XTOSMdjz {
	font-size: 72px;
	line-height: 64px;
}

.FGJE28lrlOYPPjgUQiEk {
	font-size: 50px;
	font-weight: 400;
	line-height: 40px;
}

.EQwTNzAyY0YnPgGBezFb {
	font-size: 100px;
	line-height: 100px;
}

.smTMWUX2tF6ypljtp8Gb {
	text-align: center;
}

.IDE9RHbV41_j6fGQJ9FQ {
	color: #000;
}

.mhgeZKgvevIwhd9j94Nc {
	color: #fff;
}

.VZqOi47fX5O0_fIemAvB {
	background-color: #F6F4F1;
	z-index: 2;
	position: relative;
	flex-shrink: 0;
}

.fsKdFY214g58JO86LEAG {
	cursor: pointer;
}

.CZw3XtxfQjjZPQV6f4ku {
	position: relative;
	height: 100%;
	max-width: 100%;
	display: flex;
}

@media (max-width: 500px) {
	.CZw3XtxfQjjZPQV6f4ku {
		/*justify-content: flex-end;*/
	}
}

.HHiJk2_Te4SWlXJW3HE3 {
	width: 300px;
	max-width: 100%;
	z-index: 3;
	position: absolute;
}

@media (max-width: 1060px) {
	.HHiJk2_Te4SWlXJW3HE3 {
		width: 150px;
	}
}

@media (max-width: 500px) {
	.HHiJk2_Te4SWlXJW3HE3 {
		/*right: 0 !important;*/
		bottom: 0 !important;
		margin-right: -50px;
		margin-bottom: -120px;
		position: relative;
	}
}

@media (max-width: 450px) {
	.HHiJk2_Te4SWlXJW3HE3 {
		margin-bottom: -50px;
	}
}

.Z44DNinsXk3jKQEknAL9 {
	flex-grow: 1;
}

.IRgTslTByW0y8MiktN2A {
	display: inline-block;
	margin: 0;
	filter: drop-shadow(0px 50px 50px rgba(0, 0, 0, 0.25));
}

.ADMCs5Qzkahnsadz_MVt {
	transform: rotate(30deg);
}

.W38V_WuLOUmQb4hG3pDA {
	display: flex;
	justify-content: space-between;
	align-items: center;
}

.B72K68B1A23ePG2Kmybq {
	display: flex;
	justify-content: center;
	align-items: center;
}

.ZfiSB7cCcvWMrKuitkBX {
	flex-direction: column;
}

.ewR58Db18B6dRQZsKY4X {
	flex-direction: row-reverse;
}

.v_LOn1KklXbUjh3JFNSq {
	height: 812px;
	max-width: 1440px;
	display: flex;
	align-items: center;
}

@media (max-width: 700px) {
	.v_LOn1KklXbUjh3JFNSq {
		height: auto;
		margin-top: 20px;
		padding: 0 20px;
		width: 100%;
	}
}

.vs7xS8Gph4JQ9q8rExRP {
	width: 440px;
	height: 439px;
	border-radius: 100000px;
	margin-right: 100px;
	object-fit: contain;
	filter: drop-shadow(-50px 0px 100px rgba(0, 0, 0, 0.25));
}

.ewR58Db18B6dRQZsKY4X .vs7xS8Gph4JQ9q8rExRP {
	margin-left: 100px;
}

@media (max-width: 1000px) {
	.vs7xS8Gph4JQ9q8rExRP {
		margin-right: 10px;
	}

	.ewR58Db18B6dRQZsKY4X .vs7xS8Gph4JQ9q8rExRP {
		margin-left: 10px;
	}
}

@media (max-width: 700px) {
	.vs7xS8Gph4JQ9q8rExRP {
		max-width: 100%;
		margin: 0;
		height: auto;
	}
}

.ZI6DDjvjPAQmAqcykGbV {
	font-size: 144px;
	line-height: 120px;
}

@media (max-width: 1000px) {
	.ZI6DDjvjPAQmAqcykGbV {
		font-size: 80px;
		line-height: 85px;
	}
}

.tdgr4OSKcLCkXukomNeA {
	font-size: 64px;
	line-height: 120px;
}

@media (max-width: 1000px) {
	.tdgr4OSKcLCkXukomNeA {
		font-size: 35px;
		line-height: 60px;
	}
}

.ns3gdF3DjufpeVefI9qa {
	font-size: 55px;
	line-height: 82px;
}

@media (max-width: 1000px) {
	.ns3gdF3DjufpeVefI9qa {
		font-size: 30px;
		line-height: 60px;
	}
}

.ewR58Db18B6dRQZsKY4X .bbpQuRPEeqcASt3God5C {
	margin-left: 124px;
	text-align: right;
}

@media (max-width: 1000px) {
	.ewR58Db18B6dRQZsKY4X .bbpQuRPEeqcASt3God5C {
		margin-left: 10px;
	}
}

.HpzAi1qcxNxHH3cx4HH7 {
	position: fixed;
	z-index: 1;
}

.PweFCICg_OwrUqOkdxxR {
	background-color: #34495e;
	padding-top: 100px;
}

@media (max-width: 500px) {
	.PweFCICg_OwrUqOkdxxR {
		padding-top: 25px;
	}
}

.JjEE0OsPalDUQSQbCw6i {
	margin-bottom: 100px;
	max-width: 1060px;
	width: 100vw;
}

@media (max-width: 1000px) {
	.JjEE0OsPalDUQSQbCw6i {
		margin-bottom: 25px;
		justify-content: center;
	}
}

.bYUP9uMmae1jzRo7Ba5Q {
	max-width: 500px;
	width: 500px;
	height: 196px;
	position: relative;
	flex-shrink: 1;
}

.bYUP9uMmae1jzRo7Ba5Q:nth-of-type(1) {
	margin-right: 5px;
}

.bYUP9uMmae1jzRo7Ba5Q:nth-of-type(2) {
	margin-left: 5px;
}

.Ezw1FVvUGPTRbkG67qLi {
	position: absolute;
	width: 100%;
	height: 100%;
	opacity: 0.4;
}

.mpzyDbkxO15Z9NrBSp5v {
	font-size: 50px;
	line-height: 40px;
}

@media (max-width: 720px) {
	.mpzyDbkxO15Z9NrBSp5v {
		font-size: 40px;
		line-height: 30px;
	}
}

@media (max-width: 620px) {
	.mpzyDbkxO15Z9NrBSp5v {
		font-size: 30px;
		line-height: 20px;
	}
}

.ymu_FNm3gMjdY6siqJei {
	background-color: rgba(27, 109, 105, 0.22);;
	max-width: 600px;
	flex-grow: 1;
	border-radius: 30px;
}

@media (max-width: 500px) {
	.ymu_FNm3gMjdY6siqJei {
		margin: 0;
		padding-left: 10px;
		padding-right: 10px;
		margin: 0 53px;
		padding-top: 19px;
		border-radius: 10px;
	}
}

.bHZqLqY_ZLOZih3y2eDz {
	width: 100%;
	display: flex;
	border-radius: 10px;
	align-items: center;
}

@media (max-width: 500px) {
	.bHZqLqY_ZLOZih3y2eDz {
		margin-bottom: 9px;
	}
}

.Lgnlwh2g4AORIcAUSgB8, .Lgnlwh2g4AORIcAUSgB8:focus {
	width: 100%;
	background-color: inherit;
	border: none;
	border-radius: 10px;
	outline: none;
}

.Lgnlwh2g4AORIcAUSgB8::placeholder {
	opacity: 0.5;
	color: #000;
}

._qd6owrEpuRC9tLc1Q_C {
	position: fixed;
	bottom: 15px;
	right: 42px;
	width: 80px;
	cursor: pointer;
}

._qd6owrEpuRC9tLc1Q_C img {
	width: 100%;
	height: 100;
}`, "",{"version":3,"sources":["webpack://./src/styles.css"],"names":[],"mappings":"AAAA;CACC,SAAS;AACV;;AAEA;CACC,kBAAkB;CAClB,MAAM;CACN,OAAO;CACP,WAAW;CACX,YAAY;CACZ,gBAAgB;CAChB,kBAAkB;CAClB,aAAa;CACb,sBAAsB;CACtB,yBAAyB;AAC1B;;AAEA;CACC,WAAW;CACX,YAAY;AACb;;AAEA;CACC,oCAAoC;CACpC,gBAAgB;AACjB;;AAEA;CACC,mCAAmC;AACpC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,eAAe;CACf,iBAAiB;AAClB;;AAEA;CACC,eAAe;CACf,gBAAgB;CAChB,iBAAiB;AAClB;;AAEA;CACC,gBAAgB;CAChB,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,WAAW;AACZ;;AAEA;CACC,WAAW;AACZ;;AAEA;CACC,yBAAyB;CACzB,UAAU;CACV,kBAAkB;CAClB,cAAc;AACf;;AAEA;CACC,eAAe;AAChB;;AAEA;CACC,kBAAkB;CAClB,YAAY;CACZ,eAAe;CACf,aAAa;AACd;;AAEA;CACC;EACC,6BAA6B;CAC9B;AACD;;AAEA;CACC,YAAY;CACZ,eAAe;CACf,UAAU;CACV,kBAAkB;AACnB;;AAEA;CACC;EACC,YAAY;CACb;AACD;;AAEA;CACC;EACC,uBAAuB;EACvB,oBAAoB;EACpB,mBAAmB;EACnB,qBAAqB;EACrB,kBAAkB;CACnB;AACD;;AAEA;CACC;EACC,oBAAoB;CACrB;AACD;;AAEA;CACC,YAAY;AACb;;AAEA;CACC,qBAAqB;CACrB,SAAS;CACT,sDAAsD;AACvD;;AAEA;CACC,wBAAwB;AACzB;;AAEA;CACC,aAAa;CACb,8BAA8B;CAC9B,mBAAmB;AACpB;;AAEA;CACC,aAAa;CACb,uBAAuB;CACvB,mBAAmB;AACpB;;AAEA;CACC,sBAAsB;AACvB;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,aAAa;CACb,iBAAiB;CACjB,aAAa;CACb,mBAAmB;AACpB;;AAEA;CACC;EACC,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,WAAW;CACZ;AACD;;AAEA;CACC,YAAY;CACZ,aAAa;CACb,uBAAuB;CACvB,mBAAmB;CACnB,mBAAmB;CACnB,wDAAwD;AACzD;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC;EACC,kBAAkB;CACnB;;CAEA;EACC,iBAAiB;CAClB;AACD;;AAEA;CACC;EACC,eAAe;EACf,SAAS;EACT,YAAY;CACb;AACD;;AAEA;CACC,gBAAgB;CAChB,kBAAkB;AACnB;;AAEA;CACC;EACC,eAAe;EACf,iBAAiB;CAClB;AACD;;AAEA;CACC,eAAe;CACf,kBAAkB;AACnB;;AAEA;CACC;EACC,eAAe;EACf,iBAAiB;CAClB;AACD;;AAEA;CACC,eAAe;CACf,iBAAiB;AAClB;;AAEA;CACC;EACC,eAAe;EACf,iBAAiB;CAClB;AACD;;AAEA;CACC,kBAAkB;CAClB,iBAAiB;AAClB;;AAEA;CACC;EACC,iBAAiB;CAClB;AACD;;AAEA;CACC,eAAe;CACf,UAAU;AACX;;AAEA;CACC,yBAAyB;CACzB,kBAAkB;AACnB;;AAEA;CACC;EACC,iBAAiB;CAClB;AACD;;AAEA;CACC,oBAAoB;CACpB,iBAAiB;CACjB,YAAY;AACb;;AAEA;CACC;EACC,mBAAmB;EACnB,uBAAuB;CACxB;AACD;;AAEA;CACC,gBAAgB;CAChB,YAAY;CACZ,aAAa;CACb,kBAAkB;CAClB,cAAc;AACf;;AAEA;CACC,iBAAiB;AAClB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,kBAAkB;CAClB,WAAW;CACX,YAAY;CACZ,YAAY;AACb;;AAEA;CACC,eAAe;CACf,iBAAiB;AAClB;;AAEA;CACC;EACC,eAAe;EACf,iBAAiB;CAClB;AACD;;AAEA;CACC;EACC,eAAe;EACf,iBAAiB;CAClB;AACD;;AAEA;CACC,0CAA0C;CAC1C,gBAAgB;CAChB,YAAY;CACZ,mBAAmB;AACpB;;AAEA;CACC;EACC,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,iBAAiB;EACjB,mBAAmB;CACpB;AACD;;AAEA;CACC,WAAW;CACX,aAAa;CACb,mBAAmB;CACnB,mBAAmB;AACpB;;AAEA;CACC;EACC,kBAAkB;CACnB;AACD;;AAEA;CACC,WAAW;CACX,yBAAyB;CACzB,YAAY;CACZ,mBAAmB;CACnB,aAAa;AACd;;AAEA;CACC,YAAY;CACZ,WAAW;AACZ;;AAEA;CACC,eAAe;CACf,YAAY;CACZ,WAAW;CACX,WAAW;CACX,eAAe;AAChB;;AAEA;CACC,WAAW;CACX,WAAW;AACZ","sourcesContent":["body {\n\tmargin: 0;\n}\n\n.appRoot {\n\tposition: absolute;\n\ttop: 0;\n\tleft: 0;\n\twidth: 100%;\n\theight: 100%;\n\toverflow-y: auto;\n\toverflow-x: hidden;\n\tdisplay: flex;\n\tflex-direction: column;\n\tbackground-color: #f6f4f1;\n}\n\n.mainImage {\n\twidth: 100%;\n\theight: 100%;\n}\n\n.text_standard {\n\tfont-family: \"Suranna\", \"sans-serif\";\n\tfont-weight: 400;\n}\n\n.text_ubuntu {\n\tfont-family: \"Ubuntu\", \"sans-serif\";\n}\n\n.text_unna {\n\tfont-family: \"Unna\", \"sans-serif\";\n}\n\n.text_header1 {\n\tfont-size: 72px;\n\tline-height: 64px;\n}\n\n.text_header2 {\n\tfont-size: 50px;\n\tfont-weight: 400;\n\tline-height: 40px;\n}\n\n.text_header3 {\n\tfont-size: 100px;\n\tline-height: 100px;\n}\n\n.text_center {\n\ttext-align: center;\n}\n\n.color_primary {\n\tcolor: #000;\n}\n\n.color_secondary {\n\tcolor: #fff;\n}\n\n.header {\n\tbackground-color: #F6F4F1;\n\tz-index: 2;\n\tposition: relative;\n\tflex-shrink: 0;\n}\n\n.header_clickable {\n\tcursor: pointer;\n}\n\n.header_image_container {\n\tposition: relative;\n\theight: 100%;\n\tmax-width: 100%;\n\tdisplay: flex;\n}\n\n@media (max-width: 500px) {\n\t.header_image_container {\n\t\t/*justify-content: flex-end;*/\n\t}\n}\n\n.header_image {\n\twidth: 300px;\n\tmax-width: 100%;\n\tz-index: 3;\n\tposition: absolute;\n}\n\n@media (max-width: 1060px) {\n\t.header_image {\n\t\twidth: 150px;\n\t}\n}\n\n@media (max-width: 500px) {\n\t.header_image {\n\t\t/*right: 0 !important;*/\n\t\tbottom: 0 !important;\n\t\tmargin-right: -50px;\n\t\tmargin-bottom: -120px;\n\t\tposition: relative;\n\t}\n}\n\n@media (max-width: 450px) {\n\t.header_image {\n\t\tmargin-bottom: -50px;\n\t}\n}\n\n.body_outer {\n\tflex-grow: 1;\n}\n\n.hex_outer {\n\tdisplay: inline-block;\n\tmargin: 0;\n\tfilter: drop-shadow(0px 50px 50px rgba(0, 0, 0, 0.25));\n}\n\n.hex_inner {\n\ttransform: rotate(30deg);\n}\n\n.flex_between {\n\tdisplay: flex;\n\tjustify-content: space-between;\n\talign-items: center;\n}\n\n.flex_center {\n\tdisplay: flex;\n\tjustify-content: center;\n\talign-items: center;\n}\n\n.flex_column {\n\tflex-direction: column;\n}\n\n.flex_flip_horiz {\n\tflex-direction: row-reverse;\n}\n\n.staff_holder {\n\theight: 812px;\n\tmax-width: 1440px;\n\tdisplay: flex;\n\talign-items: center;\n}\n\n@media (max-width: 700px) {\n\t.staff_holder {\n\t\theight: auto;\n\t\tmargin-top: 20px;\n\t\tpadding: 0 20px;\n\t\twidth: 100%;\n\t}\n}\n\n.staff_image {\n\twidth: 440px;\n\theight: 439px;\n\tborder-radius: 100000px;\n\tmargin-right: 100px;\n\tobject-fit: contain;\n\tfilter: drop-shadow(-50px 0px 100px rgba(0, 0, 0, 0.25));\n}\n\n.flex_flip_horiz .staff_image {\n\tmargin-left: 100px;\n}\n\n@media (max-width: 1000px) {\n\t.staff_image {\n\t\tmargin-right: 10px;\n\t}\n\n\t.flex_flip_horiz .staff_image {\n\t\tmargin-left: 10px;\n\t}\n}\n\n@media (max-width: 700px) {\n\t.staff_image {\n\t\tmax-width: 100%;\n\t\tmargin: 0;\n\t\theight: auto;\n\t}\n}\n\n.staff_name {\n\tfont-size: 144px;\n\tline-height: 120px;\n}\n\n@media (max-width: 1000px) {\n\t.staff_name {\n\t\tfont-size: 80px;\n\t\tline-height: 85px;\n\t}\n}\n\n.staff_title {\n\tfont-size: 64px;\n\tline-height: 120px;\n}\n\n@media (max-width: 1000px) {\n\t.staff_title {\n\t\tfont-size: 35px;\n\t\tline-height: 60px;\n\t}\n}\n\n.staff_description {\n\tfont-size: 55px;\n\tline-height: 82px;\n}\n\n@media (max-width: 1000px) {\n\t.staff_description {\n\t\tfont-size: 30px;\n\t\tline-height: 60px;\n\t}\n}\n\n.flex_flip_horiz .staff_data {\n\tmargin-left: 124px;\n\ttext-align: right;\n}\n\n@media (max-width: 1000px) {\n\t.flex_flip_horiz .staff_data {\n\t\tmargin-left: 10px;\n\t}\n}\n\n.expandable_hover {\n\tposition: fixed;\n\tz-index: 1;\n}\n\n.skill_tab_outer {\n\tbackground-color: #34495e;\n\tpadding-top: 100px;\n}\n\n@media (max-width: 500px) {\n\t.skill_tab_outer {\n\t\tpadding-top: 25px;\n\t}\n}\n\n.skill_row {\n\tmargin-bottom: 100px;\n\tmax-width: 1060px;\n\twidth: 100vw;\n}\n\n@media (max-width: 1000px) {\n\t.skill_row {\n\t\tmargin-bottom: 25px;\n\t\tjustify-content: center;\n\t}\n}\n\n.skill_holder {\n\tmax-width: 500px;\n\twidth: 500px;\n\theight: 196px;\n\tposition: relative;\n\tflex-shrink: 1;\n}\n\n.skill_holder:nth-of-type(1) {\n\tmargin-right: 5px;\n}\n\n.skill_holder:nth-of-type(2) {\n\tmargin-left: 5px;\n}\n\n.skill_image {\n\tposition: absolute;\n\twidth: 100%;\n\theight: 100%;\n\topacity: 0.4;\n}\n\n.skill_text {\n\tfont-size: 50px;\n\tline-height: 40px;\n}\n\n@media (max-width: 720px) {\n\t.skill_text {\n\t\tfont-size: 40px;\n\t\tline-height: 30px;\n\t}\n}\n\n@media (max-width: 620px) {\n\t.skill_text {\n\t\tfont-size: 30px;\n\t\tline-height: 20px;\n\t}\n}\n\n.contact_outer {\n\tbackground-color: rgba(27, 109, 105, 0.22);;\n\tmax-width: 600px;\n\tflex-grow: 1;\n\tborder-radius: 30px;\n}\n\n@media (max-width: 500px) {\n\t.contact_outer {\n\t\tmargin: 0;\n\t\tpadding-left: 10px;\n\t\tpadding-right: 10px;\n\t\tmargin: 0 53px;\n\t\tpadding-top: 19px;\n\t\tborder-radius: 10px;\n\t}\n}\n\n.input_holder {\n\twidth: 100%;\n\tdisplay: flex;\n\tborder-radius: 10px;\n\talign-items: center;\n}\n\n@media (max-width: 500px) {\n\t.input_holder {\n\t\tmargin-bottom: 9px;\n\t}\n}\n\n.input, .input:focus {\n\twidth: 100%;\n\tbackground-color: inherit;\n\tborder: none;\n\tborder-radius: 10px;\n\toutline: none;\n}\n\n.input::placeholder {\n\topacity: 0.5;\n\tcolor: #000;\n}\n\n.homeFab {\n\tposition: fixed;\n\tbottom: 15px;\n\tright: 42px;\n\twidth: 80px;\n\tcursor: pointer;\n}\n\n.homeFab img {\n\twidth: 100%;\n\theight: 100;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"appRoot": `WO8JZfaKjRnIyH4eGREN`,
	"mainImage": `POk2ODQ8g1C24rtnd0Yj`,
	"text_standard": `HQkGPWFwuPmBz9Rd5L5n`,
	"text_ubuntu": `rinBbFrkPv3bK7ZgkW6t`,
	"text_unna": `QH2WsPgEwuZnEjgJYuYG`,
	"text_header1": `h6NXetLtM8f7XTOSMdjz`,
	"text_header2": `FGJE28lrlOYPPjgUQiEk`,
	"text_header3": `EQwTNzAyY0YnPgGBezFb`,
	"text_center": `smTMWUX2tF6ypljtp8Gb`,
	"color_primary": `IDE9RHbV41_j6fGQJ9FQ`,
	"color_secondary": `mhgeZKgvevIwhd9j94Nc`,
	"header": `VZqOi47fX5O0_fIemAvB`,
	"header_clickable": `fsKdFY214g58JO86LEAG`,
	"header_image_container": `CZw3XtxfQjjZPQV6f4ku`,
	"header_image": `HHiJk2_Te4SWlXJW3HE3`,
	"body_outer": `Z44DNinsXk3jKQEknAL9`,
	"hex_outer": `IRgTslTByW0y8MiktN2A`,
	"hex_inner": `ADMCs5Qzkahnsadz_MVt`,
	"flex_between": `W38V_WuLOUmQb4hG3pDA`,
	"flex_center": `B72K68B1A23ePG2Kmybq`,
	"flex_column": `ZfiSB7cCcvWMrKuitkBX`,
	"flex_flip_horiz": `ewR58Db18B6dRQZsKY4X`,
	"staff_holder": `v_LOn1KklXbUjh3JFNSq`,
	"staff_image": `vs7xS8Gph4JQ9q8rExRP`,
	"staff_name": `ZI6DDjvjPAQmAqcykGbV`,
	"staff_title": `tdgr4OSKcLCkXukomNeA`,
	"staff_description": `ns3gdF3DjufpeVefI9qa`,
	"staff_data": `bbpQuRPEeqcASt3God5C`,
	"expandable_hover": `HpzAi1qcxNxHH3cx4HH7`,
	"skill_tab_outer": `PweFCICg_OwrUqOkdxxR`,
	"skill_row": `JjEE0OsPalDUQSQbCw6i`,
	"skill_holder": `bYUP9uMmae1jzRo7Ba5Q`,
	"skill_image": `Ezw1FVvUGPTRbkG67qLi`,
	"skill_text": `mpzyDbkxO15Z9NrBSp5v`,
	"contact_outer": `ymu_FNm3gMjdY6siqJei`,
	"input_holder": `bHZqLqY_ZLOZih3y2eDz`,
	"input": `Lgnlwh2g4AORIcAUSgB8`,
	"homeFab": `_qd6owrEpuRC9tLc1Q_C`
};
export default ___CSS_LOADER_EXPORT___;
